export const SLIDE_ACTION_TYPES = {
    url: 'url',
    none: 'none',
    gameLaunch: 'gameLaunch'
};

export const SLIDE_CONTENT_TYPES = {
    image: 'image',
    webContent: 'webContent'
};
